




import {Component, Prop, Vue} from "vue-property-decorator";
import {PriceListStore} from "../../store";

@Component({
    name: "PriceListLabel"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly id!: number;

    get label() {
        return `${PriceListStore.data[this.id]?.code} - ${PriceListStore.data[this.id]?.name}`;
    }
}
